<script setup lang="ts">
import nextIcon from '@/assets/icons/blog/next.svg'
import prevIcon from '@/assets/icons/blog/prev.svg'
import type { TDataPagination } from '@/ts/interfaces/BlogPagination'

const props = defineProps<{
    pagination: TDataPagination
}>()

const { previous, next, pages, current } = props.pagination
</script>

<template>
    <section class="page-plus flex items-center justify-center">
        <a
            v-if="previous"
            :href="previous.links.self.href"
            class="mr-6 flex size-6 cursor-pointer items-center justify-center"
        >
            <AtomImage
                :src="prevIcon"
                alt=""
            />
        </a>
        <div
            v-if="current.number"
            class="flex justify-center gap-4"
        >
            <a
                v-for="item in pages"
                :key="item.number"
                :href="item?.links?.self.href || '#'"
                :tabindex="item.number === current.number ? '-1' : '0'"
                class="flex size-8 items-center justify-center rounded-sm border-2 border-plush-primary bg-white text-plush-primary"
                :class="{
                    'pointer-events-none cursor-default border-none !bg-plush-primary text-plush-secondary':
                        item.number === current.number,
                }"
            >
                {{ item.number }}
            </a>
        </div>
        <a
            v-if="next"
            :href="next.links.self.href"
            class="ml-6 flex size-6 items-center justify-center"
        >
            <AtomImage
                :src="nextIcon"
                alt=""
            />
        </a>
    </section>
</template>
